"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LocaleContent = exports.normalizeContentLocale = void 0;
const locales_1 = require("../enums/locales");
const normalizeContentLocale = (locale) => {
    if (locale === locales_1.Locales.FR) {
        return locales_1.Locales.FR;
    }
    if (locale === locales_1.Locales.ES) {
        return locales_1.Locales.ES;
    }
    return locales_1.Locales.EN;
};
exports.normalizeContentLocale = normalizeContentLocale;
const EMAIL_EMPTY_LINE = "<p><br></p>";
exports.LocaleContent = {
    DonationTypeLabel: {
        [locales_1.Locales.EN]: "Donation",
        [locales_1.Locales.FR]: "Don",
        [locales_1.Locales.ES]: "Donación",
    },
    DonationTypeLabelLowercase: {
        [locales_1.Locales.EN]: "donation",
        [locales_1.Locales.FR]: "don",
        [locales_1.Locales.ES]: "donación",
    },
    TicketTypeLabel: {
        [locales_1.Locales.EN]: "Ticket",
        [locales_1.Locales.FR]: "Billet",
        [locales_1.Locales.ES]: "Entrada",
    },
    NameQuestionLabel: {
        [locales_1.Locales.EN]: "Name",
        [locales_1.Locales.FR]: "Nom",
        [locales_1.Locales.ES]: "Nombre",
    },
    ReferralLabel: {
        [locales_1.Locales.EN]: "Referrals",
        [locales_1.Locales.FR]: "Parrainages",
        [locales_1.Locales.ES]: "Referidos",
    },
    ChatGreeting: {
        [locales_1.Locales.EN]: "Hi",
        [locales_1.Locales.FR]: "Bonjour",
        [locales_1.Locales.ES]: "Hola",
    },
    LanguageLabel: {
        [locales_1.Locales.EN]: "English",
        [locales_1.Locales.FR]: "French (Canadian)",
        [locales_1.Locales.ES]: "Spanish",
    },
    ReminderEmailPrefix: {
        [locales_1.Locales.EN]: "[Reminder] ",
        [locales_1.Locales.FR]: "[Rappel] ",
        [locales_1.Locales.ES]: "[Recordatorio] ",
    },
    FollowUpPrefix: {
        [locales_1.Locales.EN]: "Follow up:",
        [locales_1.Locales.FR]: "Suivi :",
        [locales_1.Locales.ES]: "Seguimiento:",
    },
    ReceiptCanceledLabel: {
        [locales_1.Locales.EN]: "Canceled",
        [locales_1.Locales.FR]: "Annulé",
        [locales_1.Locales.ES]: "Cancelado",
    },
    MembershipExpirationSubject: {
        [locales_1.Locales.EN]: "Your membership expires in a month",
        [locales_1.Locales.FR]: "Votre adhésion expire dans un mois",
        [locales_1.Locales.ES]: "Tu membresía expira en un mes",
    },
    FakeReceiptAddress: {
        [locales_1.Locales.EN]: "1 Down Avenue",
        [locales_1.Locales.FR]: "1 rue Notre-Dame Est",
        [locales_1.Locales.ES]: "Calle Falsa 123",
    },
    YesLabel: {
        [locales_1.Locales.EN]: "Yes",
        [locales_1.Locales.FR]: "Oui",
        [locales_1.Locales.ES]: "Sí",
    },
    NoLabel: {
        [locales_1.Locales.EN]: "No",
        [locales_1.Locales.FR]: "Non",
        [locales_1.Locales.ES]: "No",
    },
    UntitledQuestionLabel: {
        [locales_1.Locales.EN]: "Untitled question",
        [locales_1.Locales.FR]: "Question sans titre",
        [locales_1.Locales.ES]: "Pregunta sin título",
    },
    UntitledChoiceLabel: {
        [locales_1.Locales.EN]: "Untitled choice",
        [locales_1.Locales.FR]: "Choix sans titre",
        [locales_1.Locales.ES]: "Opción sin título",
    },
    UntitledTicketLabel: {
        [locales_1.Locales.EN]: "Untitled ticket",
        [locales_1.Locales.FR]: "Billet sans titre",
        [locales_1.Locales.ES]: "Entrada sin título",
    },
    UntitledMembershipLabel: {
        [locales_1.Locales.EN]: "Untitled membership",
        [locales_1.Locales.FR]: "Adhésion sans titre",
        [locales_1.Locales.ES]: "Membresía sin título",
    },
    UntitledItemLabel: {
        [locales_1.Locales.EN]: "Untitled item",
        [locales_1.Locales.FR]: "Article sans titre",
        [locales_1.Locales.ES]: "Artículo sin título",
    },
    UntitledCampaignLabel: {
        [locales_1.Locales.EN]: "Untitled campaign",
        [locales_1.Locales.FR]: "Campagne sans titre",
        [locales_1.Locales.ES]: "Campaña sin título",
    },
    DefaultOrganizationName: {
        [locales_1.Locales.EN]: "My Organization",
        [locales_1.Locales.FR]: "Mon Organisation",
        [locales_1.Locales.ES]: "Mi Organización",
    },
    GivingTuesdayContent: {
        [locales_1.Locales.EN]: {
            emailContent: '<p style="width:100%;margin-top:0px;margin-bottom:0px;box-sizing:inherit;color:rgb(0, 0, 0)">Dear <span contenteditable="false" data-custom-variable="{{firstname}}" fr-original-class="fr-deletable styled-tag-chip">First name</span>,</p><p style="width:100%;margin-top:0px;margin-bottom:0px;box-sizing:inherit;color:rgb(0, 0, 0)"><br /></p><p style="width:100%;margin-top:0px;margin-bottom:0px;box-sizing:inherit;color:rgb(0, 0, 0)">We are beyond grateful for your generous support this giving season! Because of donors like you, we are able to come together as a community and make a significant impact throughout this season of giving.</p><p style="width:100%;margin-top:0px;margin-bottom:0px;box-sizing:inherit;color:rgb(0, 0, 0)"><br /></p><p style="width:100%;margin-top:0px;margin-bottom:0px;box-sizing:inherit;color:rgb(0, 0, 0)">Your donation is already making a difference, helping us work towards our mission. We couldn\'t do this without you!</p><p style="width:100%;margin-top:0px;margin-bottom:0px;box-sizing:inherit;color:rgb(0, 0, 0)"><br /></p><p style="width:100%;margin-top:0px;margin-bottom:0px;box-sizing:inherit;color:rgb(0, 0, 0)">Every single gift counts, and your kindness is helping us take meaningful steps toward a brighter, more hopeful future. Thank you for believing in our cause and for standing with us during this giving season.</p><p style="width:100%;margin-top:0px;margin-bottom:0px;box-sizing:inherit;color:rgb(0, 0, 0)"><br /></p><p style="width:100%;margin-top:0px;margin-bottom:0px;box-sizing:inherit;color:rgb(0, 0, 0)">We\'ll be sure to keep you updated on the positive change you\'ve helped create!</p><p style="width:100%;margin-top:0px;margin-bottom:0px;box-sizing:inherit;color:rgb(0, 0, 0)"><br /></p><p style="width:100%;margin-top:0px;margin-bottom:0px;box-sizing:inherit;color:rgb(0, 0, 0)">All the best,<br />{userName}<br />{orgName}</p>',
            emailObject: "Thank You for Your Incredible Support this giving season!",
        },
        [locales_1.Locales.FR]: {
            emailContent: '<p style="width:100%;margin-top:0px;margin-bottom:0px;box-sizing:inherit;color:rgb(0, 0, 0)">Cher <span contenteditable="false" data-custom-variable="{{firstname}}" fr-original-class="fr-deletable styled-tag-chip">Prénom</span>,</p><p style="width:100%;margin-top:0px;margin-bottom:0px;box-sizing:inherit;color:rgb(0, 0, 0)"><br /></p><p style="width:100%;margin-top:0px;margin-bottom:0px;box-sizing:inherit;color:rgb(0, 0, 0)">Nous sommes extrêmement reconnaissants de votre soutien généreux cette saison des dons ! Grâce à des donateurs comme vous, nous pouvons nous rassembler en tant que communauté et avoir un impact significatif tout au long de cette saison de générosité.</p><p style="width:100%;margin-top:0px;margin-bottom:0px;box-sizing:inherit;color:rgb(0, 0, 0)"><br /></p><p style="width:100%;margin-top:0px;margin-bottom:0px;box-sizing:inherit;color:rgb(0, 0, 0)">Votre don fait déjà la différence et nous aide à accomplir notre mission. Nous ne pourrions pas faire cela sans vous !</p><p style="width:100%;margin-top:0px;margin-bottom:0px;box-sizing:inherit;color:rgb(0, 0, 0)"><br /></p><p style="width:100%;margin-top:0px;margin-bottom:0px;box-sizing:inherit;color:rgb(0, 0, 0)">Chaque don compte, et votre gentillesse nous aide à prendre des mesures significatives pour un avenir meilleur et plein d\'espoir. Nous vous remercions de croire en notre cause et de vous tenir à nos côtés pendant cette saison des dons.</p><p style="width:100%;margin-top:0px;margin-bottom:0px;box-sizing:inherit;color:rgb(0, 0, 0)"><br /></p><p style="width:100%;margin-top:0px;margin-bottom:0px;box-sizing:inherit;color:rgb(0, 0, 0)">Nous ne manquerons pas de vous tenir au courant des changements positifs que vous avez contribué à créer !</p><p style="width:100%;margin-top:0px;margin-bottom:0px;box-sizing:inherit;color:rgb(0, 0, 0)"><br /></p><p style="width:100%;margin-top:0px;margin-bottom:0px;box-sizing:inherit;color:rgb(0, 0, 0)">Tous mes vœux de réussite,</p><p style="width:100%;margin-top:0px;margin-bottom:0px;box-sizing:inherit;color:rgb(0, 0, 0)">{userName}</p><p style="width:100%;margin-top:0px;margin-bottom:0px;box-sizing:inherit;color:rgb(0, 0, 0)">{orgName}</p>',
            emailObject: "Merci pour votre incroyable soutien cette saison des dons !",
        },
        [locales_1.Locales.ES]: {
            emailContent: '<p style="width:100%;margin-top:0px;margin-bottom:0px;box-sizing:inherit;color:rgb(0, 0, 0)">Estimado <span contenteditable="false" data-custom-variable="{{firstname}}" fr-original-class="fr-deletable styled-tag-chip">Nombre</span>,</p><p style="width:100%;margin-top:0px;margin-bottom:0px;box-sizing:inherit;color:rgb(0, 0, 0)"><br /></p><p style="width:100%;margin-top:0px;margin-bottom:0px;box-sizing:inherit;color:rgb(0, 0, 0)">¡Estamos extremadamente agradecidos por tu generoso apoyo esta temporada de donaciones! Gracias a donantes como tú, podemos unirnos como comunidad y tener un impacto significativo durante toda esta temporada de generosidad.</p><p style="width:100%;margin-top:0px;margin-bottom:0px;box-sizing:inherit;color:rgb(0, 0, 0)"><br /></p><p style="width:100%;margin-top:0px;margin-bottom:0px;box-sizing:inherit;color:rgb(0, 0, 0)">Tu donación ya está marcando la diferencia y nos ayuda a cumplir nuestra misión. ¡No podríamos hacer esto sin ti!</p><p style="width:100%;margin-top:0px;margin-bottom:0px;box-sizing:inherit;color:rgb(0, 0, 0)"><br /></p><p style="width:100%;margin-top:0px;margin-bottom:0px;box-sizing:inherit;color:rgb(0, 0, 0)">Cada donación cuenta, y tu amabilidad nos ayuda a dar pasos significativos hacia un futuro más brillante y esperanzador. Gracias por creer en nuestra causa y por apoyarnos durante esta temporada de donaciones.</p><p style="width:100%;margin-top:0px;margin-bottom:0px;box-sizing:inherit;color:rgb(0, 0, 0)"><br /></p><p style="width:100%;margin-top:0px;margin-bottom:0px;box-sizing:inherit;color:rgb(0, 0, 0)">¡Nos aseguraremos de mantenerte informado sobre los cambios positivos que has ayudado a crear!</p><p style="width:100%;margin-top:0px;margin-bottom:0px;box-sizing:inherit;color:rgb(0, 0, 0)"><br /></p><p style="width:100%;margin-top:0px;margin-bottom:0px;box-sizing:inherit;color:rgb(0, 0, 0)">Todos mis mejores deseos,<br />{userName}<br />{orgName}</p>',
            emailObject: "¡Gracias por tu increíble apoyo esta temporada de donaciones!",
        },
    },
    StytchMagicLinkLoginTemplateId: {
        [locales_1.Locales.EN]: "membership_magical_link_login",
        [locales_1.Locales.FR]: "membership_magical_link_login_fr",
        [locales_1.Locales.ES]: "membership_magical_link_login",
    },
    StytchMagicLinkBidderLoginTemplateId: {
        [locales_1.Locales.EN]: "bidder_magical_link_login",
        [locales_1.Locales.FR]: "bidder_magical_link_login_fr",
        [locales_1.Locales.ES]: "bidder_magical_link_login",
    },
    StytchMagicLinkRecurringDonationLoginTemplateId: {
        [locales_1.Locales.EN]: "recurring_donation_magical_link_login_en",
        [locales_1.Locales.FR]: "recurring_donation_magical_link_login_fr",
        [locales_1.Locales.ES]: "recurring_donation_magical_link_login_en",
    },
    StytchEmailOtpBidderTemplateId: {
        [locales_1.Locales.EN]: "bidder_email_otp",
        [locales_1.Locales.FR]: "bidder_email_otp_fr",
        [locales_1.Locales.ES]: "bidder_email_otp",
    },
    StytchForgotPasswordTemplateId: {
        [locales_1.Locales.EN]: "forgot_password_en",
        [locales_1.Locales.FR]: "forgot_password_fr",
        [locales_1.Locales.ES]: "forgot_password_en",
    },
    StytchCreatePasswordTemplateId: {
        [locales_1.Locales.EN]: "create_password_en",
        [locales_1.Locales.FR]: "create_password_fr",
        [locales_1.Locales.ES]: "create_password_es",
    },
    DonationAutoRenewalSubject: {
        [locales_1.Locales.EN]: "Your recurring donation renews soon ✨",
        [locales_1.Locales.FR]: "Votre don récurrent se renouvelle bientôt ✨",
        [locales_1.Locales.ES]: "Tu donación recurrente se renueva pronto ✨",
    },
    DonationAutoRenewalBody: {
        [locales_1.Locales.EN]: ({ orgName, firstName, renewalDate, renewalAmount, paymentMethod, signature, }) => `<p>Hi ${firstName},</p>` +
            EMAIL_EMPTY_LINE +
            `<p>Your recurring donation to ${orgName} will be charged on ${renewalDate}.</p>` +
            EMAIL_EMPTY_LINE +
            `<p><strong>Amount:</strong> ${renewalAmount}<br/><strong>Payment method:</strong> ${paymentMethod}</p>` +
            EMAIL_EMPTY_LINE +
            `<p>Thank you for your continued support.</p>` +
            EMAIL_EMPTY_LINE +
            signature,
        [locales_1.Locales.FR]: ({ orgName, firstName, renewalDate, renewalAmount, paymentMethod, signature, }) => `<p>Bonjour ${firstName},</p>` +
            EMAIL_EMPTY_LINE +
            `<p>Votre don récurrent à ${orgName} sera prélevé le ${renewalDate}.</p>` +
            EMAIL_EMPTY_LINE +
            `<p><strong>Montant :</strong> ${renewalAmount}<br/><strong>Méthode de paiement :</strong> ${paymentMethod}</p>` +
            EMAIL_EMPTY_LINE +
            `<p>Merci pour votre soutien continu.</p>` +
            EMAIL_EMPTY_LINE +
            signature,
        [locales_1.Locales.ES]: ({ orgName, firstName, renewalDate, renewalAmount, paymentMethod, signature, }) => `<p>Hola ${firstName},</p>` +
            EMAIL_EMPTY_LINE +
            `<p>Tu donación recurrente a ${orgName} se cobrará el ${renewalDate}.</p>` +
            EMAIL_EMPTY_LINE +
            `<p><strong>Monto:</strong> ${renewalAmount}<br/><strong>Método de pago:</strong> ${paymentMethod}</p>` +
            EMAIL_EMPTY_LINE +
            `<p>Gracias por tu apoyo continuo.</p>` +
            EMAIL_EMPTY_LINE +
            signature,
    },
    PaymentNotificationBody: {
        [locales_1.Locales.EN]: ({ name, formattedAmount }) => `${name} made a ${formattedAmount} payment to your cause`,
        [locales_1.Locales.FR]: ({ name, formattedAmount }) => `${name} a fait un paiement de ${formattedAmount} à votre cause`,
        [locales_1.Locales.ES]: ({ name, formattedAmount }) => `${name} hizo un pago de ${formattedAmount} a tu causa`,
    },
    DonationFormHeaderMeta: {
        [locales_1.Locales.EN]: ({ orgName, formTitle }) => ({
            metaTitle: `Donate to ${orgName} | Zeffy`,
            metaDescription: `Help ${orgName} raise funds for ${formTitle}. Make a donation on Zeffy, and ensure 100% of your donation goes to fund ${orgName}’s mission.`,
        }),
        [locales_1.Locales.FR]: ({ orgName, formTitle }) => ({
            metaTitle: `Faites un don à ${orgName} | Zeffy`,
            metaDescription: `Aidez ${orgName} à collecter des fonds pour ${formTitle}. Faites un don sur Zeffy et assurez-vous que 100 % de votre don soit consacré à la mission de ${orgName}.`,
        }),
        [locales_1.Locales.ES]: ({ orgName, formTitle }) => ({
            metaTitle: `Dona a ${orgName} | Zeffy`,
            metaDescription: `Ayuda a ${orgName} a recaudar fondos para ${formTitle}. Haz una donación en Zeffy y asegúrate de que el 100% de tu donación se destine a la misión de ${orgName}.`,
        }),
    },
    P2pHeaderMeta: {
        [locales_1.Locales.EN]: ({ orgName, campaignTitle }) => ({
            metaTitle: `Donate to ${campaignTitle} | ${orgName} | Zeffy`,
            metaDescription: `Help ${orgName} raise funds for ${campaignTitle}. Donate securely on Zeffy — 100% of your donation goes to the nonprofit.`,
        }),
        [locales_1.Locales.FR]: ({ orgName, campaignTitle }) => ({
            metaTitle: `Faites un don à ${campaignTitle} | ${orgName} | Zeffy`,
            metaDescription: `Aidez ${orgName} à collecter des fonds pour ${campaignTitle}. Faites un don sécurisé sur Zeffy - 100 % de votre don est reversé à l'association.`,
        }),
        [locales_1.Locales.ES]: ({ orgName, campaignTitle }) => ({
            metaTitle: `Dona a ${campaignTitle} | ${orgName} | Zeffy`,
            metaDescription: `Ayuda a ${orgName} a recaudar fondos para ${campaignTitle}. Dona de forma segura en Zeffy - el 100 % de tu donación se destina a la organización sin fines de lucro.`,
        }),
    },
    TeamHeaderMeta: {
        [locales_1.Locales.EN]: ({ orgName, teamName, campaignTitle, }) => ({
            metaTitle: `Support ${teamName} for ${campaignTitle} | ${orgName} | Zeffy`,
            metaDescription: `${teamName} is fundraising for ${orgName}’s ${campaignTitle}. Make a donation on Zeffy and support their cause — 100% of your gift goes to the nonprofit.`,
        }),
        [locales_1.Locales.FR]: ({ orgName, teamName, campaignTitle, }) => ({
            metaTitle: `Soutenez ${teamName} pour ${campaignTitle} | ${orgName} | Zeffy`,
            metaDescription: `${teamName} collecte des fonds pour ${campaignTitle} de ${orgName}. Faites un don sur Zeffy et soutenez sa cause - 100 % de votre don est reversé à l'association à but non lucratif.`,
        }),
        [locales_1.Locales.ES]: ({ orgName, teamName, campaignTitle, }) => ({
            metaTitle: `Apoya a ${teamName} en ${campaignTitle} | ${orgName} | Zeffy`,
            metaDescription: `${teamName} está recaudando fondos para ${campaignTitle} de ${orgName}. Haz una donación en Zeffy y apoya su causa - el 100% de su donación se destina a la organización sin fines de lucro.`,
        }),
    },
    OrganizationPageHeaderMeta: {
        [locales_1.Locales.EN]: ({ orgName }) => ({
            metaTitle: `${orgName} | Zeffy`,
            metaDescription: `Support ${orgName}. Learn more about their mission and make a donation on Zeffy — 100% of your donation goes to the nonprofit.`,
        }),
        [locales_1.Locales.FR]: ({ orgName }) => ({
            metaTitle: `${orgName} | Zeffy`,
            metaDescription: `Soutenez ${orgName}. Découvrez leur mission et faites un don sur Zeffy - 100 % de votre don est reversé à l'association.`,
        }),
        [locales_1.Locales.ES]: ({ orgName }) => ({
            metaTitle: `${orgName} | Zeffy`,
            metaDescription: `Apoya a ${orgName}. Conoce más sobre su misión y haz una donación en Zeffy - el 100% de tu donación se destina a la organización sin fines de lucro.`,
        }),
    },
    TicketingEventHeaderMeta: {
        [locales_1.Locales.EN]: ({ title, orgName, address, startDate, }) => {
            const addressTitlePart = address ? ` at ${address}` : "";
            const startDatePart = startDate ? ` on ${startDate}` : "";
            const addressDescriptionPart = address ? ` at ${address}` : "";
            return {
                metaTitle: `${title} - Charity event${addressTitlePart} | ${orgName} | Zeffy`,
                metaDescription: `Join us for ${title}, a fundraising event hosted by ${orgName}${startDatePart}${addressDescriptionPart}. Buy your ticket with Zeffy — 100% of proceeds go to ${orgName}.`,
            };
        },
        [locales_1.Locales.FR]: ({ title, orgName, address, startDate, }) => {
            const addressTitlePart = address ? ` à ${address}` : "";
            const startDatePart = startDate ? ` le ${startDate}` : "";
            const addressDescriptionPart = address ? ` à ${address}` : "";
            return {
                metaTitle: `${title} - Événement caritatif${addressTitlePart} | ${orgName} | Zeffy`,
                metaDescription: `Rejoignez-nous pour ${title}, un événement de collecte de fonds organisé par ${orgName}${startDatePart}${addressDescriptionPart}. Achetez votre billet avec Zeffy — 100 % des bénéfices seront reversées à ${orgName}.`,
            };
        },
        [locales_1.Locales.ES]: ({ title, orgName, address, startDate, }) => {
            const addressTitlePart = address ? ` en ${address}` : "";
            const startDatePart = startDate ? ` el ${startDate}` : "";
            const addressDescriptionPart = address ? ` en ${address}` : "";
            return {
                metaTitle: `${title} - Evento benéfico${addressTitlePart} | ${orgName} | Zeffy`,
                metaDescription: `Únete a nosotros en ${title}, un evento benéfico organizado por ${orgName}${startDatePart}${addressDescriptionPart}. Compra tu entrada con Zeffy - 100% de las ganancias van a ${orgName}.`,
            };
        },
    },
    TicketingMembershipHeaderMeta: {
        [locales_1.Locales.EN]: ({ title, orgName }) => ({
            metaTitle: `${title} | ${orgName} | Zeffy`,
            metaDescription: `Make a payment to ${title}. Zeffy is 100% free - 100% of your payment goes directly to ${orgName}.`,
        }),
        [locales_1.Locales.FR]: ({ title, orgName }) => ({
            metaTitle: `${title} | ${orgName} | Zeffy`,
            metaDescription: `Effectuez un paiement à ${title}. Zeffy est 100 % gratuit  - 100 % de votre paiement est reversé directement à ${orgName}.`,
        }),
        [locales_1.Locales.ES]: ({ title, orgName }) => ({
            metaTitle: `${title} | ${orgName} | Zeffy`,
            metaDescription: `Realiza un pago a ${title}. Zeffy es 100 % gratuito: el 100 % de tu pago se destina directamente a ${orgName}.`,
        }),
    },
    TicketingLotteryHeaderMeta: {
        [locales_1.Locales.EN]: ({ title, orgName }) => ({
            metaTitle: `${title} | ${orgName} | Zeffy`,
            metaDescription: `Enter ${orgName}'s fundraising raffle to support their mission. Raffle tickets available on Zeffy — 100% of proceeds go to the nonprofit.`,
        }),
        [locales_1.Locales.FR]: ({ title, orgName }) => ({
            metaTitle: `${title} | ${orgName} | Zeffy`,
            metaDescription: `Participez à la tombola de ${orgName} pour soutenir sa mission. Billets disponibles sur Zeffy — 100 % des bénéfices reversés à l'association.`,
        }),
        [locales_1.Locales.ES]: ({ title, orgName }) => ({
            metaTitle: `${title} | ${orgName} | Zeffy`,
            metaDescription: `Participa en la rifa de recaudación de fondos de ${orgName} para apoyar su misión. Boletos de la rifa disponibles en Zeffy - el 100 % de las ganancias se destina a la organización sin fines de lucro.`,
        }),
    },
    TicketingSweepstakesHeaderMeta: {
        [locales_1.Locales.EN]: ({ title, orgName }) => ({
            metaTitle: `${title} | ${orgName} | Zeffy`,
            metaDescription: `Enter ${orgName}'s sweepstakes to support their mission. No donation is necessary to enter.`,
        }),
        [locales_1.Locales.FR]: ({ title, orgName }) => ({
            metaTitle: `${title} | ${orgName} | Zeffy`,
            metaDescription: `Participez au concours promotionnel de ${orgName} pour soutenir sa mission. Aucun don n'est requis pour participer.`,
        }),
        [locales_1.Locales.ES]: ({ title, orgName }) => ({
            metaTitle: `${title} | ${orgName} | Zeffy`,
            metaDescription: `Participa en el sorteo promocional de ${orgName} para apoyar su misión. No es necesario donar para participar.`,
        }),
    },
    TicketingAuctionHeaderMeta: {
        [locales_1.Locales.EN]: ({ orgName }) => ({
            metaTitle: `Silent Auction – ${orgName} | Zeffy`,
            metaDescription: `Bid to support ${orgName}'s silent auction. Hosted on Zeffy — the only 100% free silent auction platform for nonprofits.`,
        }),
        [locales_1.Locales.FR]: ({ orgName }) => ({
            metaTitle: `Vente aux enchères silencieuse – ${orgName} | Zeffy`,
            metaDescription: `Enchérissez pour soutenir la vente aux enchères silencieuse de ${orgName}. Hébergée sur Zeffy, la seule plateforme de vente aux enchères silencieuse 100 % gratuite pour les associations.`,
        }),
        [locales_1.Locales.ES]: ({ orgName }) => ({
            metaTitle: `Subasta silenciosa – ${orgName} | Zeffy`,
            metaDescription: `Puja para apoyar la subasta silenciosa de ${orgName}. Organizada por Zeffy, la única plataforma de subastas silenciosas 100 % gratuita para organizaciones sin fines de lucro.`,
        }),
    },
    TicketingShopHeaderMeta: {
        [locales_1.Locales.EN]: ({ orgName }) => ({
            metaTitle: `${orgName}'s Online Store | Zeffy`,
            metaDescription: `Browse ${orgName}'s online store and support their mission with every purchase. Powered by Zeffy — 100% of proceeds go to the nonprofit.`,
        }),
        [locales_1.Locales.FR]: ({ orgName }) => ({
            metaTitle: `Boutique en ligne de ${orgName} | Zeffy`,
            metaDescription: `Parcourez la boutique en ligne de ${orgName} et soutenez sa mission à chaque achat. Propulsé par Zeffy — 100 % des bénéfices reversés à l'association.`,
        }),
        [locales_1.Locales.ES]: ({ orgName }) => ({
            metaTitle: `Tienda en línea de ${orgName} | Zeffy`,
            metaDescription: `Explora la tienda en línea de ${orgName} y apoya su misión con cada compra. Impulsado por Zeffy - el 100 % de las ganancias se destina a la organización sin fines de lucro.`,
        }),
    },
};
